import React from 'react';
import { X } from 'lucide-react';
import { C } from '../theme.js';

// Context so ColSelect / MultiCols (and every inspector they live inside)
// automatically receive the active column list without explicit prop drilling.
export const ColumnsContext = React.createContext(null);

// Original source-file schema (before any pipeline step ran), independent of
// ColumnsContext's live "columns arriving at this step" schema. Scaling and
// encoding pickers use this so a column added by an earlier scaling/encoding
// step (e.g. mrr_min_max_scaled) is never itself offered for scaling/encoding.
export const OriginalColumnsContext = React.createContext(null);

 

// ── Selectable column chips ────────────────────────────────────────────
export function ColumnChips({ all, selected, onToggle }) {
  const allNames = new Set(all.map(c => c.name));
  const stale = selected.filter(n => !allNames.has(n));
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {stale.map(name => (
        <button
          key={name}
          onClick={() => onToggle(name)}
          title="Column not in current file — click to remove"
          style={{
            fontFamily: 'inherit',
            cursor: 'pointer',
            background: C.error,
            color: '#fff',
            border: `1px solid ${C.error}`,
            borderRadius: 6,
            padding: '4px 9px',
            fontSize: '.74rem',
            fontWeight: 600,
            display: 'inline-flex', alignItems: 'center', gap: 5,
            transition: 'all .15s',
            opacity: .85,
          }}
        >
          {name}
          <span style={{ display: 'inline-flex' }}><X size={11} /></span>
        </button>
      ))}
      {all.map(col => {
        const on = selected.includes(col.name);
        return (
          <button
            key={col.name}
            onClick={() => onToggle(col.name)}
            style={{
              fontFamily: 'inherit',
              cursor: 'pointer',
              background: on ? C.accentStrong : C.input,
              color: on ? '#fff' : C.fg3,
              border: `1px solid ${on ? C.accentStrong : C.borderStrong}`,
              borderRadius: 6,
              padding: '4px 9px',
              fontSize: '.74rem',
              fontWeight: 600,
              display: 'inline-flex', alignItems: 'center', gap: 5,
              transition: 'all .15s',
            }}
          >
            {col.name}
            <span style={{
              fontSize: '.6rem', textTransform: 'uppercase',
              color: on ? 'rgba(255,255,255,.65)' : C.fg5,
              letterSpacing: '.06em',
            }}>{col.type}</span>
          </button>
        );
      })}
    </div>
  );
}

// ── Generic segmented control ───────────────────────────────────────────
export function Segmented({ value, onChange, options }) {
  return (
    <div style={{
      display: 'flex', background: C.input, border: `1px solid ${C.borderStrong}`,
      borderRadius: 8, padding: 3,
    }}>
      {options.map(o => {
        const on = value === o.value;
        const disabled = !!o.disabled;
        return (
          <button
            key={o.value}
            title={disabled ? o.disabledReason : undefined}
            disabled={disabled}
            onClick={() => !disabled && onChange(o.value)}
            style={{
              flex: 1, fontFamily: 'inherit', cursor: disabled ? 'not-allowed' : 'pointer',
              background: on ? 'linear-gradient(135deg,#1d4ed8,#1e40af)' : 'transparent',
              color: on ? '#fff' : disabled ? C.fg6 : C.fg4,
              opacity: disabled ? 0.55 : 1,
              border: 'none', borderRadius: 6,
              padding: '6px 10px', fontSize: '.74rem', fontWeight: 600,
              transition: 'all .15s',
            }}
          >{o.label}</button>
        );
      })}
    </div>
  );
}
